import { ReactNode } from 'react'
import { Flex } from 'antd'
import Title from 'shared/components/typography/Title'
import Text from 'shared/components/typography/Text'
import s from './s.module.css'

interface Props {
  children: ReactNode
  title?: ReactNode
  description?: ReactNode
  icon?: ReactNode
}

function Card({ children, title, icon, description }: Props) {
  return (
    <div className={s.container}>
      {icon && <div className={s.icon}>{icon}</div>}
      <Flex vertical gap={4} className={s.textContainer}>
        {title && (
          <Title level={2} fontType="header" fontSize={2}>
            {title}
          </Title>
        )}
        {description && (
          <Text fontType="body" fontSize={16}>
            {description}
          </Text>
        )}
      </Flex>
      {children}
    </div>
  )
}

export default Card
